import { FC, ReactNode } from "react";

interface ChatbotPreviewBackgroundProps {
  children: ReactNode;
}

export const ChatbotPreviewBackground: FC<ChatbotPreviewBackgroundProps> = ({
  children,
}) => (
  <div
    className="flex h-full w-full items-center justify-center bg-[#FEFFFF]"
    style={{
      backgroundImage:
        "linear-gradient(rgba(112, 117, 119, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(112, 117, 119, 0.05) 1px, transparent 1px)",
      backgroundSize: "20px 20px",
    }}
  >
    {children}
  </div>
);
